import { defineMessages } from 'react-intl';

const messages = defineMessages({
  sendNotifications: {
    description: 'shipmentObjectContainer.sendNotifications',
    defaultMessage: 'Send Notifications',
    id: 'zSSGYL',
  },
});

export default messages;
